import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LayoutHeader from './components/LayoutHeader';
import LayoutFooter from './components/LayoutFooter';
import HomePage from './pages/HomePage';
import ConvertidorPage from './pages/ConvertidorPage';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-800 dark:text-gray-200">
        <LayoutHeader />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/convertidor" element={<ConvertidorPage />} />
        </Routes>
        <LayoutFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;
